import { render, staticRenderFns } from "./PageColumnWithVisitorEditor.vue?vue&type=template&id=713f4c88&lang=pug&"
import script from "./PageColumnWithVisitorEditor.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithVisitorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithVisitorEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports